import { useStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { ref } from "vue";
import { useDefaultTasksViews } from "@/Pages/Tasks/Views";
import { useDefaultFilesViews } from "@/Pages/Files/Views";
import { useDefaultAssetsViews } from "@/Pages/Assets/Views";
import { useDefaultSpacesViews } from "@/Pages/Spaces/Views";
import { useDefaultRecurringTasksViews } from "@/Pages/RecurringTasks/Views";

export const FILTERS = "filters";
export const DEFAULT_FILTER_TYPES = "default_filter_types";
export const ACTIVE_VIEW = "active_view";

export const useFiltersStore = defineStore("filters", () => {
    const { DefaultView: DefaultTasksView } = useDefaultTasksViews();
    const { DefaultView: DefaultFilesView } = useDefaultFilesViews();
    const { DefaultView: DefaultAssetsView } = useDefaultAssetsViews();
    const { DefaultView: DefaultSpacesView } = useDefaultSpacesViews();
    const { DefaultView: DefaultRecurringTasksView } =
        useDefaultRecurringTasksViews();

    const global = ref(
        useStorage("global-filters", {
            [FILTERS]: {},
            [DEFAULT_FILTER_TYPES]: [],
        })
    );

    const assets = ref({
        [FILTERS]: {},
        [DEFAULT_FILTER_TYPES]: [],
        [ACTIVE_VIEW]: DefaultAssetsView.ALL,
    });

    const files = ref({
        [FILTERS]: {},
        [DEFAULT_FILTER_TYPES]: [],
        [ACTIVE_VIEW]: DefaultFilesView.ALL,
    });

    const tasks = ref({
        [FILTERS]: {},
        [DEFAULT_FILTER_TYPES]: [],
        [ACTIVE_VIEW]: DefaultTasksView.ALL,
    });

    const spaces = ref({
        [FILTERS]: {},
        [DEFAULT_FILTER_TYPES]: [],
        [ACTIVE_VIEW]: DefaultSpacesView.ALL,
    });

    const recurring_tasks = ref({
        [FILTERS]: {},
        [DEFAULT_FILTER_TYPES]: [],
        [ACTIVE_VIEW]: DefaultRecurringTasksView.ALL,
    });

    return {
        global,
        assets,
        files,
        tasks,
        spaces,
        recurring_tasks,
    };
});
